import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { Store } from '@df/catalog/store/store';
import { App } from '@df/core/app';
import { GoogleMapComponentDef } from '@df/module-google-maps/google-map/google-map.component.def';
import { GoogleMaps } from '@df/module-google-maps/google-maps.namespace';
import { GoogleMapsService } from '@df/module-google-maps/google-maps.service';
import { GtmService } from '@df/module-gtm/gtm.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { CheckoutCollectionComponent } from './checkout-collection.component';
import { MetapackCollectionPoint } from './metapack/metapack-collection-point';
import { Metapack } from './metapack/metapack.namespace';

declare module '@df/module-google-maps/google-maps.namespace' {
    namespace GoogleMaps {
        interface IMarkerOptions {
            model?: Store | MetapackCollectionPoint;
        }
    }
}

@Component({
    selector: 'checkout-collection-google-map',
    template: '',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutCollectionGoogleMapComponent extends GoogleMapComponentDef {
    constructor(
        element: ElementRef,
        app: App,
        timeoutService: TimeoutService,
        googleMapsService: GoogleMapsService,
        private checkoutCollectionComponent: CheckoutCollectionComponent,
        gtm: GtmService
    ) {
        super(element, app, timeoutService, googleMapsService);
        gtm.trackNonInteractionEvent('gmaps', 'collectionMap', app.isPlatformBrowser ? location.pathname : 'universal');
    }

    protected override getConverter(): GoogleMaps.MarkerConverter | undefined {
        return (store: Store | MetapackCollectionPoint, options: google.maps.MarkerOptions) => {
            const opts = { ...options, model: store };
            const iconUrl = `/assets/images/checkout-collection-marker-${
                store.type === Metapack.COLLECTION_POINT_TYPE ? 'collection-point' : 'store'
            }.svg`;

            opts.icon = {
                url: iconUrl,
                scaledSize: new google.maps.Size(50, 50)
            };

            return opts;
        };
    }

    protected override onMarkerClick(markerSetup: GoogleMaps.IMarkerOptions, marker: google.maps.Marker): void {
        this.checkoutCollectionComponent.currentMapModel = markerSetup.model!;
    }
}
